// libs
import React, { memo } from 'react';

// components
import { COUPON_TYPE } from 'shared/layouts/Coupons/types';
import ViewDetailsNudgeDesktopOffer from 'shared/layouts/Coupons/ViewDetailsNudge/ViewDetailsNudgeOffers';
import { SHEET_TRANSITION } from 'shared/components/OverlaySheet';

// constants
import { EMPTY_COUPON_DATA, TEXTS } from 'shared/layouts/Coupons/constants';
import { OFFER_PROPERTIES } from './constants';

// styles
import {
  ActionContainerDetails,
  ContainerWrapper,
  ViewDetailsNudgeDesktopCoupon,
  ViewDetailsNudgeMobileNew,
  ViewDetailsNudgeMobileOffer,
} from './styles';

import { ActionButtonCoupon, CopyButtonPDP } from 'shared/layouts/Coupons/ViewDetailsNudge/styles';

// hook

import useFetchCouponDetails from './useFetchCouponDetails';

export enum PreviewFrom {
  PDP = 'pdp',
  BestPrice = 'bestPrice',
}

enum OFFERS_CTA {
  BACK = 'Back',
  OKAY = 'Okay',
}

interface CouponOfferDetailsProps {
  isDesktop?: boolean;
  showDetailCoupon: ProductOffers.ShowDetailCoupon;
  setCopySuccessMessage: (message: string) => void;
  setshowDetailCoupon: (couponDetailsToShow: ProductOffers.ShowDetailCoupon) => void;
  onCopyClicked: (code: string) => void;
  className?: string;
  sheetTransition?: SHEET_TRANSITION;
  previewFrom?: PreviewFrom;
  setParentSheetHeight?: (height: number) => void | null;
  showOverlay?: boolean;
}

function CouponOfferDetails({
  isDesktop = false,
  showDetailCoupon,
  setCopySuccessMessage,
  setshowDetailCoupon,
  onCopyClicked,
  className = '',
  sheetTransition = SHEET_TRANSITION.BOTTOM,
  previewFrom = PreviewFrom.PDP,
  setParentSheetHeight,
  showOverlay = true,
}: CouponOfferDetailsProps) {
  const resetShowDetails = () =>
    setshowDetailCoupon({
      showDetails: false,
      coupon: EMPTY_COUPON_DATA,
      disabled: false,
      type: '',
    });

  const { currentCouponDetails, currentOfferDetails } = useFetchCouponDetails(showDetailCoupon);

  const onHide = () => {
    resetShowDetails();
    setCopySuccessMessage('');
  };

  const getCouponDetailActionContainer = (doHide: () => void) => {
    return (
      <ActionContainerDetails>
        <ActionButtonCoupon kind={'secondary'} size={'medium'} shape={'default'} onClick={doHide}>
          {previewFrom === PreviewFrom.BestPrice ? TEXTS.BACK : TEXTS.DISMISS}
        </ActionButtonCoupon>
        <CopyButtonPDP
          onClick={() => onCopyClicked(currentCouponDetails?.couponCode || '')}
          disabled={false}
        >
          {TEXTS.COPY_CODE}
        </CopyButtonPDP>
      </ActionContainerDetails>
    );
  };

  return (
    <>
      <ContainerWrapper data-test="container-coupon" parentOverflow={!isDesktop}>
        {showDetailCoupon.showDetails ? (
          isDesktop ? (
            <>
              {showDetailCoupon.type === COUPON_TYPE.COUPON && (
                <ViewDetailsNudgeDesktopCoupon
                  couponDetails={currentCouponDetails}
                  onHide={onHide}
                  onCopyClicked={onCopyClicked}
                  className={className}
                />
              )}
              {showDetailCoupon.type === COUPON_TYPE.OFFER && (
                <ViewDetailsNudgeDesktopOffer offerDetails={currentOfferDetails} onHide={onHide} />
              )}
            </>
          ) : (
            <>
              {showDetailCoupon.type === COUPON_TYPE.COUPON && (
                <ViewDetailsNudgeMobileNew
                  couponDetails={currentCouponDetails}
                  onHide={onHide}
                  isApplied={false}
                  logoHeight={OFFER_PROPERTIES.PREVIEW_LOGO_HEIGHT}
                  logoWidth={OFFER_PROPERTIES.PREVIEW_LOGO_WIDTH}
                  actionContainer={(doHide) => getCouponDetailActionContainer(doHide)}
                  className={className}
                  sheetTransition={sheetTransition}
                  showBackButton={previewFrom === PreviewFrom.BestPrice}
                  setParentSheetHeight={setParentSheetHeight}
                  showOverlay={showOverlay}
                />
              )}
              {showDetailCoupon.type === COUPON_TYPE.OFFER && (
                <ViewDetailsNudgeMobileOffer
                  offerDetails={currentOfferDetails}
                  onHide={onHide}
                  className={className}
                  sheetTransition={sheetTransition}
                  actionContainerText={
                    previewFrom === PreviewFrom.BestPrice ? OFFERS_CTA.BACK : OFFERS_CTA.OKAY
                  }
                  showBackButton={previewFrom === PreviewFrom.BestPrice}
                  showOverlay={showOverlay}
                />
              )}
            </>
          )
        ) : null}
      </ContainerWrapper>
    </>
  );
}

export default memo(CouponOfferDetails);
